import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
export const handleFocus = (WrappedComponent, Span = 'span') => class Focus extends Component {
    constructor() {
        super(...arguments);
        this.state = { focus: false };
        this.handleFocus = () => this.setState({ focus: true });
        this.handleBlur = () => this.setState({ focus: false });
    }
    render() {
        return (_jsx(Span, { onFocus: this.handleFocus, onBlur: this.handleBlur, children: _jsx(WrappedComponent, { ...this.props, ...this.state }) }));
    }
};
//# sourceMappingURL=interaction.js.map